import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { ErrorAlert } from '@/components/ErrorAlert';
import { LoadingIcon } from '@/components/LoadingIcon';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { OrdersTable } from '@/features/orders/OrdersTable';

export const Route = createFileRoute('/a/orders/')({
  staticData: {
    breadcrumbs: [{ label: 'Orders' }],
  },
  component: AdminOrderListPage,
});

function AdminOrderListPage() {
  const ordersQuery = useQuery(api.orders.listRecent);
  if (ordersQuery.isPending) return <LoadingIcon />;
  if (ordersQuery.isError) {
    return <ErrorAlert message={ordersQuery.error.message} title="Error loading orders" />;
  }

  return (
    <div className="min-h-[calc(100vh-(--spacing(16)))] flex-1 flex-col gap-4">
      <Card>
        <CardHeader>
          <CardTitle>Orders</CardTitle>
        </CardHeader>
        <CardContent>
          <OrdersTable orders={ordersQuery.data} showRestaurantColumn />
        </CardContent>
      </Card>
    </div>
  );
}
